module.exports = __webpack_public_path__ + "static/media/intelligent1.ee74b0ae.png";